import { newLP, rid, coItems } from './collect';
import { sameCo } from './coRemove';
import type { Project, Collect } from './types';

/** 등록정보(p.cos) → 자료수집 동기화: 빈 값 백필 + 누락 법인 추가 + LP 이름 디폴트(덮어쓰기 금지) */
const LEGACY_TYPE: Record<string, string> = { '단문': 'text', '장문': 'text_long', '파일': 'file', '날짜': 'text', '숫자': 'text' };

export function syncCollectFromReg(p: Project, base: Collect): Collect | null {
  const c = JSON.parse(JSON.stringify(base)) as Collect;
  let changed = false;
  const cards = [c.gp, ...c.lps, ...c.cos];
  cards.forEach((card) => {
    (card.items || []).forEach((it) => {
      const nv = LEGACY_TYPE[it.type];
      if (nv) { it.type = nv; changed = true; }
    });
  });
  const regCos = (p.cos || []).filter((x) => !!(x.name || x.bizno || x.ceo));
  if (!regCos.length) return changed ? c : null;
  const used = new Set<string>();
  regCos.forEach((rc, i) => {
    // 같은 회사 찾기 — 사업자번호 또는 이름(주식회사 · (주) · 띄어쓰기 무시 · 2026-11-02: 글자만 조금 달라도 카드를 하나 더 만들어 회사별 진행이 두 줄이 되던 것)
    let co = c.cos.find((x) => !used.has(x.id) && sameCo(x, rc));
    if (!co) co = c.cos.find((x) => !used.has(x.id) && !x.name && !x.bizno);
    if (co) {
      used.add(co.id);
      if (!co.name && rc.name) { co.name = rc.name; changed = true; }
      if (!co.bizno && rc.bizno) { co.bizno = rc.bizno; changed = true; }
      if (!co.companyId && rc.companyId) { co.companyId = rc.companyId; changed = true; }
    } else {
      let rep: string;
      if (i === 0 && p.gp && !c.cos.some((x) => x.rep === 'gp')) {
        rep = 'gp';
      } else {
        const freeLp = c.lps.find((l) => !l.name && !c.cos.some((x) => x.rep === 'lp:' + l.id));
        if (freeLp) {
          if (rc.ceo) {
            freeLp.name = rc.ceo;
            if (freeLp.recips[0] && !freeLp.recips[0].name) {
              freeLp.recips[0].name = rc.ceo;
              if (!freeLp.recips[0].tel) freeLp.recips[0].tel = rc.mgrTel || '';
            }
          }
          rep = 'lp:' + freeLp.id;
        } else {
          const lp = newLP(rc.ceo || '', rc.mgrTel || '');
          c.lps.push(lp);
          rep = 'lp:' + lp.id;
        }
      }
      c.cos.push({ id: rid(), name: rc.name || '', bizno: rc.bizno || '', companyId: rc.companyId || null, rep, items: coItems() });
      changed = true;
    }
  });
  c.cos.forEach((co) => {
    if (!co.rep.startsWith('lp:')) return;
    const lp = c.lps.find((l) => 'lp:' + l.id === co.rep);
    if (!lp || lp.name) return;
    const rc = regCos.find((x) => (!!x.bizno && x.bizno === co.bizno) || (!!x.name && x.name === co.name));
    if (rc && rc.ceo) {
      lp.name = rc.ceo;
      if (lp.recips[0] && !lp.recips[0].name) {
        lp.recips[0].name = rc.ceo;
        if (!lp.recips[0].tel) lp.recips[0].tel = rc.mgrTel || '';
      }
      changed = true;
    }
  });
  c.cos.forEach((co) => {
    if (co.rep === 'gp' && !c.gp.bizno && co.bizno) { c.gp.bizno = co.bizno; changed = true; }
  });
  return changed ? c : null;
}
